export default __webpack_public_path__ + "static/media/keyboard-backspace.fb6fab7c.svg";